import React, { useEffect, useState } from "react";
import { TabsBase } from "@reusejs/react";
import { getAllAuctionEvents } from "services";
import AuctionEventCard from "./BidderEvent";

export default function ViewAllEvents() {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    // we can filter the below data so that we dont have to make many api calls
    const result: any = await getAllAuctionEvents(["pending", "accepted"]);
    setEvents(result?.data || []);
  };
  console.log("This is coming from all events---->>>>", events);

  return (
    <div className="w-full p-4 sm:p-6 min-h-screen">
      <div className="min-w-full flex justify-between">
        <div className="text-4xl text-blue-600 font-extrabold dark:text-red-600">
          All Auction Events
        </div>
      </div>
      <TabsBase
        elements={[
          {
            title: <div className="flex items-center px-2">All Events</div>,
            content: (
              <div className="flex w-full justify-center border-2 border-t-0 rounded-b-lg bg-gray-50 border-gray-200">
                <div className="w-full p-4 sm:p-6 mt-4 space-y-6">
                  {events.length > 0 ? (
                    events.map((item: any, index: number) => {
                      return (
                        <AuctionEventCard
                          key={index}
                          property={item.property_dump}
                          event={item}
                          type="allEvents"
                        />
                      );
                    })
                  ) : (
                    <div className="w-full flex justify-center">No Events</div>
                  )}
                </div>
              </div>
            ),
          },
        ]}
        tabsBaseClasses={{
          wrapperClasses: "pt-16",
          layout: "flex items-center justify-center",
          height: "h-full",
          width: "w-full min-w-fit",
          backgroundColor: "bg-white",
          padding: "px-2",
          cursor: "cursor-pointer",
          borderRadius: "rounded-t-lg",
          border: "border-2 border-gray-200",
          activeTabClasses:
            "sticky left-0 right-0 bg-gray-50 border-b-0 scale-y-125 origin-bottom font-bold",
          inactiveTabClasses: "border-gray-200",
        }}
      />
    </div>
  );
}
